import { render, staticRenderFns } from "./InstructionManualModal.vue?vue&type=template&id=76a53f5c&scoped=true"
import script from "./InstructionManualModal.vue?vue&type=script&lang=js"
export * from "./InstructionManualModal.vue?vue&type=script&lang=js"
import style0 from "./InstructionManualModal.vue?vue&type=style&index=0&id=76a53f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a53f5c",
  null
  
)

export default component.exports